import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../App.css";
import {
  faGlobe,
  faUserCircle,
  faHome,
  faArrowRight,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons"; // Import a regular style icon
import Map from "../components/Map.js";
import Footer from "../components/Footer.js";

const Home = () => {
  const [data, setdata] = useState([]);
  const [loader, setloader] = useState(0);

  const sliderData = [
    {
      id: 1,
      country: "Switzerland",
      population: "8.66M",
      territory: "41,234 KM2",
      avgprice: "$1.100.200",
      backgroundImg:
        "https://images.unsplash.com/photo-1682685796852-aa311b46f50d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDF8MHxzZWFyY2h8MXx8bmF0dXJlfGVufDB8fDB8fHww",
    },
    {
      id: 2,
      country: "Thailand",
      population: "10.66M",
      territory: "41,2734 KM2",
      avgprice: "$1.100.200",
      backgroundImg:
        "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8bmF0dXJlfGVufDB8fDB8fHww",
    },
    {
      id: 3,
      country: "Caribbean",
      population: "8.66M",
      territory: "41,234 KM2",
      avgprice: "$1.100.200",
      backgroundImg:
        "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fG5hdHVyZXxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
      id: 4,
      country: "France",
      population: "11.66M",
      territory: "41,236364 KM2",
      avgprice: "$1.100.200",
      backgroundImg:
        "https://images.unsplash.com/photo-1682685796014-2f342188a635?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDF8MHxzZWFyY2h8MTV8fG5hdHVyZXxlbnwwfHwwfHx8MA%3D%3D",
    },
  ];

  let index = 0;

  function loopWithDelay() {
    // console.log(sliderData[index]);
    setdata([sliderData[index]]);
    setloader(index);
    index = (index + 1) % sliderData.length;

    setTimeout(loopWithDelay, 5000);
  }

  useEffect(() => {
    loopWithDelay();
  }, [sliderData.length]);

  return (
    <div className="max-w-7xl">
      <Navbar />
      <section>
        {data.map((data, index) => (
          <div
            key={index}
            className="bg-cover bg-center transition-all ease-in-out width-full h-auto text-white text-center   "
            style={{ backgroundImage: `url(${data.backgroundImg})` }}
          >
            <div className="flex flex-col justify-center items-center  bg-opacity-50 p-3 md:p-8 h-full w-full  bg-black backdrop-brightness-20">
              <p className="text-base md:text-xl mt-20 font-semibold">
                Take A Glimpse InTo Beautiful Country Of:
              </p>
              <h1 className="font-bold text-4xl md:text-6xl mt-5">
                {data.country}
              </h1>
              <Link className="border p-3 mt-10 hover:bg-cyan-500 hover:text-white transition-all w-32 rounded-3xl border-cyan-500 text-cyan-500">
                Go There
              </Link>
              <div className="grid grid-cols-2 md:grid-cols-4 w-full md:w-11/12 p-4 md:p-8 mt-10 bg-yellow-50 rounded-3xl md:rounded-full">
                <div className="flex flex-row justify-center items-center mx-5 md:mx-8 my-5 md:my-0">
                  <FontAwesomeIcon
                    icon={faUserCircle}
                    className="text-cyan-500 text-5xl"
                  />
                  <div className="ml-3 flex flex-col  items-start">
                    <p className="text-gray-800 font-light">Population:</p>
                    <p className="text-cyan-500 text-sm md:text-lg font-bold">
                      {data.population}
                    </p>
                  </div>
                </div>
                <div className="flex flex-row justify-center items-center mx-5 md:mx-8 my-5 md:my-0">
                  <FontAwesomeIcon
                    icon={faGlobe}
                    className="text-cyan-500 text-5xl"
                  />
                  <div className="ml-3 flex flex-col  items-start">
                    <p className="text-gray-800 font-light">Territory:</p>
                    <p className="text-cyan-500 text-sm md:text-lg font-bold">
                      {data.territory}
                    </p>
                  </div>
                </div>
                <div className="flex flex-row justify-center items-center mx-4 md:mx-8 my-5 md:my-0">
                  <FontAwesomeIcon
                    icon={faHome}
                    className="text-cyan-500 text-5xl"
                  />
                  <div className="ml-3 flex flex-col  items-start">
                    <p className="text-gray-800 font-light">AVG Price:</p>
                    <p className="text-cyan-500 font-bold text-sm md:text-lg">
                      {data.avgprice}
                    </p>
                  </div>
                </div>
                <div className="bg-cyan-500 hover:bg-cyan-400 transition-all m-5 text-center py-3 px-3 md:px-6 rounded-3xl md:rounded-full font-medium md:font-semibold">
                  <button>Explore More</button>
                </div>
              </div>
              <div className="flex loader-grand-parent">
                <div className="loader-first-grand-parent">
                  <div className="loader-parent mx-2 md:mx-5">
                    <div
                      className={`${loader === 0 ? "loader-child" : "none"}`}
                    ></div>
                  </div>
                  <h1 className="font-semibold text-lg">1</h1>
                </div>
                <div className="loader-first-grand-parent">
                  <div className="loader-parent mx-2 md:mx-5">
                    <div
                      className={`${loader === 1 ? "loader-child" : "none"}`}
                    ></div>
                  </div>
                  <h1 className="font-semibold text-lg">2</h1>
                </div>
                <div className="loader-first-grand-parent">
                  <div className="loader-parent mx-2 md:mx-5">
                    <div
                      className={`${loader === 2 ? "loader-child" : "none"}`}
                    ></div>
                  </div>
                  <h1 className="font-semibold text-lg">3</h1>
                </div>
                <div className="loader-first-grand-parent">
                  <div className={`loader-parent mx-2 md:mx-5`}>
                    <div
                      className={`${loader === 3 ? "loader-child" : "none"}`}
                    ></div>
                  </div>
                  <h1 className="font-semibold text-lg text-center">4</h1>
                </div>
              </div>
            </div>
          </div>
        ))}
      </section>
      <section className="bg-gray-800 p-3 md:p-16 text-gray-400">
        <div>
          <h1 className="text-4xl mt-5 text-gray-200">
            Visit One Of Our Countries Now
          </h1>
          <p className="mt-8">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore.
          </p>
        </div>
        <div className="flex-col  md:flex-row mt-8 md:justify-between md:flex">
          <div className="w-full md:w-2/3 h-auto ">
            <div className="flex-col md:flex md:flex-row border-b border-white py-5">
              <div className="md:w-1/4 w-full">
                <img
                  // style={{ width: "400px" }}
                  className="rounded-2xl w-full md:w-96"
                  src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/country-01.jpg"
                  alt="Switzerland"
                />
              </div>
              <div className="mt-5 md:mt-0 w-full md:w-3/4">
                <div className="flex justify-between ml-0 md:ml-5">
                  <div>
                    <h1 className="text-xl font-bold">SWITZERLAND</h1>
                    <p>Europe</p>
                  </div>
                  <div>
                    <div>
                      <button className="bg-cyan-500 hover:bg-cyan-600 text-white transition-all  text-center py-2 px-3 md:px-6 rounded-3xl md:rounded-full font-medium md:font-semibold">
                        Explore More
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="ml-0 md:ml-5 mt-3">
                    Woox Travel is a professional Bootstrap 5 theme HTML CSS
                    layout for your website. You can use this layout for your
                    commercial work.
                  </p>
                </div>
                <div className="flex ml-0 md:ml-5 mt-5 py-5 border-t border-b border-white justify-between">
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faUserCircle}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">8.66 Mil People</p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faGlobe}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">41.290 km2</p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faHome}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">$1.100.200</p>
                  </div>
                </div>
                <NavLink
                  className={
                    "mx-5 mt-5 text-cyan-500 font-semibold flex items-center hover:justify-between w-40 transition-transform ease-in-out px-1 "
                  }
                >
                  Need Direction?
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="text-cyan-500 ml-2 text-xl"
                  />
                </NavLink>
              </div>
            </div>
            <div className="flex-col md:flex md:flex-row border-b border-white py-5">
              <div className="w-full md:w-1/4">
                <img
                  // style={{ width: "470px" }}
                  className="rounded-2xl w-full md:w-96"
                  src="https://images.unsplash.com/photo-1472213984618-c79aaec7fef0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bmF0dXJlfGVufDB8MnwwfHx8MA%3D%3D"
                  alt="Switzerland"
                />
              </div>
              <div className="mt-5 md:mt-0 w-full md:w-3/4">
                <div className="flex justify-between ml-0 md:ml-5">
                  <div>
                    <h1 className="text-xl font-bold">CARIBBEAN</h1>
                    <p>North America</p>
                  </div>
                  <div>
                    <div>
                      <button className="bg-cyan-500 hover:bg-cyan-600 text-white transition-all  text-center py-2 px-3 md:px-6 rounded-3xl md:rounded-full font-medium md:font-semibold">
                        Explore More
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="ml-0 md:ml-5 mt-3">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore dolor sit amet,
                    consectetur adipiscing elit, sed do eiusmod.
                  </p>
                </div>
                <div className="flex ml-0 md:ml-5 mt-5 py-5 border-t border-b border-white justify-between">
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faUserCircle}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">44.48 Mil People</p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faGlobe}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">275.400 km2</p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faHome}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2"> $946.000</p>
                  </div>
                </div>
                <NavLink
                  className={
                    "mx-5 mt-5 text-cyan-500 font-semibold flex items-center hover:justify-between w-40 transition-transform ease-in-out px-1 "
                  }
                >
                  Need Direction?
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="text-cyan-500 ml-2 text-xl"
                  />
                </NavLink>
              </div>
            </div>
            <div className="flex-col md:flex md:flex-row border-b w-full border-white py-5">
              <div className="w-full md:w-1/4">
                <img
                  // style={{ width: "510px" }}
                  className="rounded-2xl w-full md:w-96"
                  src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/country-03.jpg"
                  alt="Switzerland"
                />
              </div>
              <div className="mt-5 md:mt-0 w-full md:w-3/4">
                <div className="flex justify-between ml-0 md:ml-5">
                  <div>
                    <h1 className="text-xl font-bold">FRANCE</h1>
                    <p>Europe</p>
                  </div>
                  <div>
                    <div>
                      <button className="bg-cyan-500 hover:bg-cyan-600 text-white transition-all  text-center py-2 px-3 md:px-6 rounded-3xl md:rounded-full font-medium md:font-semibold">
                        Explore More
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="ml-0 md:ml-5 mt-3">
                    We hope this WoOx template is useful for you, please support
                    us a{" "}
                    <NavLink className={"text-cyan-500"}>
                      small amount of PayPal
                    </NavLink>
                    to info [at] templatemo.com for our survival. We really
                    appreciate your contribution.
                  </p>
                </div>
                <div className="flex ml-0 md:ml-5 mt-5 py-5 border-t border-b border-white justify-between">
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faUserCircle}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">8.66 Mil People</p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faGlobe}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">41.290 km2</p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faHome}
                      className="text-gray-400 text-xl"
                    />
                    <p className="ml-2">$1.100.200</p>
                  </div>
                </div>
                <NavLink
                  className={
                    "mx-5 mt-5 text-cyan-500 font-semibold flex items-center hover:justify-between w-40 transition-transform ease-in-out px-1 "
                  }
                >
                  Need Direction?
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="text-cyan-500 ml-2 text-xl "
                  />
                </NavLink>
              </div>
            </div>
            <div className="w-full flex mt-5 items-center justify-center">
              <NavLink>
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className=" text-cyan-500  transition-all hover:text-white  hover:bg-cyan-500 rounded-full px-5 py-4 text-center mx-2 "
                />
              </NavLink>
              <NavLink
                className={
                  "border border-cyan-500 text-cyan-500 bg-transparent rounded-full px-5 py-3 text-center mx-2 hover:bg-cyan-500 hover:text-white transition-all"
                }
              >
                1
              </NavLink>
              <NavLink
                className={
                  "border border-cyan-500 text-white bg-cyan-500 rounded-full px-5 py-3 text-center mx-2 "
                }
              >
                2
              </NavLink>
              <NavLink
                className={
                  "border border-cyan-500 text-cyan-500 bg-transparent rounded-full px-5 py-3 text-center mx-2 hover:bg-cyan-500 hover:text-white transition-all"
                }
              >
                3
              </NavLink>
              <NavLink>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className=" text-cyan-500 transition-all hover:text-white  hover:bg-cyan-500 rounded-full px-5 py-4 text-center mx-2 "
                />
              </NavLink>
            </div>
          </div>
          <div className=" w-full md:w-1/3  md:pl-8">
          <Map />
          </div>
        </div>
      </section>
      <section
        className=" flex flex-col md:flex-row justify-between items-center text-gray-200 py-20 px-12  bg-center"
        style={{
          backgroundImage: `url(${"https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/cta-bg.jpg"})`,
        }}
      >
        <div className="flex flex-col items-center md:items-start text-center md:text-start">
          <h1 className="text-5xl font-bold">Are You Looking To Travel ?</h1>
          <p className="mt-5 text-lg font-bold">
            Make A Reservation By Clicking The Button
          </p>
        </div>
        <button className="bg-transparent mt-5 md:mt-0 hover:bg-white hover:text-cyan-500 border border-white text-white transition-all h-12   text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold">
          Book Yours Now
        </button>
      </section>
      <Footer/>
    </div>
  );
};

export default Home;
